import { PayeeDetailDrawer } from '@/features/ap_payees/components/PayeeDetailDrawer';
import { r2wc } from '@/wc/helper/render';

export const DetailApPayeeDrawer = r2wc(PayeeDetailDrawer, {
  shadow: 'open',
  props: {
    apPayeeId: 'string',
    apPayeeName: 'string',
  },
});
